module.exports = __webpack_public_path__ + "images/empry-gift-6779360c0cc5821e409e98d0e0754080.png";